<template>
  <div>
    <el-container>
      <el-header>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>运营中心</el-breadcrumb-item>
          <el-breadcrumb-item>设备控制</el-breadcrumb-item>
        </el-breadcrumb>
      </el-header>
      <el-main>
        <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
            <!--列表-->
          <el-tab-pane label="充电桩控制" name="device" v-if="checkPermission(['bee:res:deviceControl:getPiles'])">
            <pile :pileDataTable = "pileDataTable"></pile>
          </el-tab-pane>
          <el-tab-pane label="充电枪控制" name="gun" v-if="checkPermission(['bee:res:deviceControl:getList'])">
            <gun :gunDataTable = "gunDataTable"></gun>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
  </div>
</template>
<script type="text/ecmascript-6">
  import pile from './deviceControl/pile'
  import gun from './deviceControl/gun'
  import pileApi from '../../resourceCenter/api/pileApi'
  import gunApi from '../../resourceCenter/api/gunApi'
  import deviceControlApi from '../api/deviceControlApi'
  export default {
    name: 'deviceControl',
    data() {
      return {
        activeName: 'device',
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        pileDataTable:[{}],
        gunDataTable:[{}]
      }
    },
    methods:{
      handleClick(tab, event) {
/*        if (tab.name =='device'){
          this.pageparam.t = {};
          let param = Object.assign({}, this.pageparam);
          deviceControlApi.getPilePageList(param).then((res) => {
            if (res.code === 0) {
              this.pageparam.total = res.data.total;
              this.pileDataTable = res.data.records;
              // this.$message({
              //   message: res.message,
              //   type: 'success'
              // });
            } else {
              // this.$message.error(res.message);
            }
          });
        }
        if (tab.name =='gun'){
          this.pageparam.t = {}
          let param = Object.assign({}, this.pageparam)
          deviceControlApi.getGunsPageList(param).then((res) => {
            if (res.code === 0) {
              this.pageparam.total = res.data.total
              this.gunDataTable = res.data.list
              // this.$message({
              //   message: res.message,
              //   type: 'success'
              // })
            } else {
              // this.$message.error(res.message)
            }
          })
        }*/
      }
    },
    components:{
      pile,
      gun
    },
    mounted: function () {
      let tab={}
      tab.name="device"
      this.handleClick(tab)
    }
  }
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/module/operatingCenter/page/deviceControl.vue